<script lang="ts">
  export let buttonText: string = "Change";
  export let onChangeClick: () => void;
</script>

<span class="craft">
  <button
    class="craft-link link-primary link-sm hover:bg-transparent focus:outline-none focus:shadow-none"
    data-testid="change-fulfillment-method-link"
    on:click|preventDefault={onChangeClick}
  >
    {buttonText}
  </button>
</span>
